import { KeyboardEvent, useRef } from "react";
import styles from "./InputBox.module.scss";

interface InputBoxProps {
  loader?: boolean;
  inputValue?: string;
  disabled?: boolean;
  handleChange: (value: string) => void;
  onSubmit: (value: string) => void;
  placeholder: string;
  onSearchClick: (value: string) => void;
}

export const InputBox = ({
  onSearchClick,
  loader,
  inputValue,
  placeholder,
  handleChange,
  onSubmit,
  disabled,
}: InputBoxProps) => {
  const inputRef = useRef(null);

  const handleInputSubmit = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    e.preventDefault();
    onSubmit((e.target as HTMLInputElement).value);
  };

  return (
    <section
      className={styles.inputWrapper}
      style={{ opacity: loader ? 0.5 : 1 }}
    >
      <textarea
        ref={inputRef}
        disabled={disabled}
        value={inputValue}
        onChange={(e) => {
          handleChange(e.target.value);
        }}
        placeholder={placeholder}
        rows={1}
        cols={3}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleInputSubmit(e);
          }
        }}
      />
      <button
        onClick={() => onSearchClick((inputRef.current as any).value)}
        className={styles.sendButton}
      >
        <span className="material-symbols-outlined">search</span>
      </button>
    </section>
  );
};
